import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Select } from '@mui/material';

export default function SelectBox(props) {
    const [value, setValue] = React.useState('');
    const [options, setOptions] = React.useState([]);

    React.useEffect(() => {
        setValue(props.value);
        const options = props.items;
        setOptions(options);

    }, [props.value, props.items]);

    const safeValue = value !== undefined && value !== null && (value === '' || (options || []).includes(value))
        ? value
        : '';

    return (
        <FormControl fullWidth>
            <>
                <Select
                    labelId="demo"
                    id="demo-simple"
                    value={safeValue}
                    displayEmpty
                    onChange={(event) => {
                        setValue(event.target.value);
                        if (props.setValue) props.setValue(event.target.value);
                    }}
                    disabled={!props.edit}
                    style={{
                        height: '30px',
                        borderRadius: 5,
                        backgroundColor: 'white',
                        // boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.25)',
                    }}
                    sx={{
                        fontSize: '13px',
                        // '& fieldset': {
                        //     border: 'none',
                        // },
                    }}
                >
                    {options.map((opt) => {
                        return <MenuItem value={opt}  sx={{
                            '&:hover': {
                                backgroundColor: '#D3D3D3',
                                color: 'black',
                            },
                            '&.Mui-selected': {
                                backgroundColor: 'grey',
                                color: props.menuStyle?'black': '#fff',
                            },
                            '&.Mui-selected:hover': {
                                backgroundColor: 'grey',
                            },
    
                            '&.Mui-focusVisible': {
                                backgroundColor: 'grey',
                            },
    
                            '&.Mui-selected.Mui-focusVisible': {
                                backgroundColor: 'grey',
                            },
                        }}>{opt} </MenuItem>
                    })}
                </Select>
            </>
        </FormControl>
    );
}
